;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { Variant } from '@qogita/canary-client'
import { BaseButton } from '@qogita/ui/v2/base-button'
import { Button } from '@qogita/ui/v2/button'
import cloudflareLoader from 'imageLoader'
import Image from 'next/image'
import { useState } from 'react'
import Fallback from 'src/deprecated/components/shared/fallback.png'
import { ProductModal } from 'src/deprecated/components/shared/ProductName/ProductModal'
import { getQogitaProductRedirectUrl } from 'src/deprecated/utils/getQogitaProductRedirectUrl'
import { getQogitaProductUrl } from 'src/deprecated/utils/getQogitaProductUrl'
import { vercelImageLoader } from 'src/deprecated/utils/url'

type RedirectArgument = {
  gtin: Variant['gtin']
}

type FullUrlArgs = {
  variantFid: string
  slug: string
}

type ConditionalProductArgs = RedirectArgument | FullUrlArgs

type ProductNameProps = ConditionalProductArgs & {
  linkText: string
  gtinText?: string
  imageUrl: string
  onClick?: () => void
  sellingUnit?: number
}

export function ProductName({
  linkText,
  gtinText,
  imageUrl,
  onClick,
  sellingUnit,
  ...props
}: ProductNameProps) {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [useFallbackImage, setUseFallbackImage] = useState(false)

  const productUrl =
    'gtin' in props
      ? getQogitaProductRedirectUrl(props.gtin)
      : getQogitaProductUrl(props.variantFid, props.slug)

  return (
    <div className="flex items-center gap-6">
      <BaseButton
        onClick={() => {
          onClick?.()
          setIsModalVisible(true)
        }}
      >
        <div className="relative size-10">
          <Image
            src={useFallbackImage ? Fallback : imageUrl}
            layout="fixed"
            width={40}
            height={40}
            alt={linkText}
            className="cursor-pointer"
            onError={() => setUseFallbackImage(true)}
            loader={useFallbackImage ? vercelImageLoader : cloudflareLoader}
          />
        </div>
      </BaseButton>
      <div className="flex flex-col gap-1">
        <Button
          type="button"
          variant="inline-text"
          className="text-left"
          onClick={() => {
            onClick?.()
            setIsModalVisible(true)
          }}
        >
          <span className="line-clamp-1 text-gray-700">{linkText}</span>
        </Button>

        {gtinText ? (
          <div className="text-base whitespace-nowrap text-gray-500">
            GTIN: {gtinText}
          </div>
        ) : null}
        {sellingUnit === undefined ? null : (
          <div className="text-base whitespace-nowrap text-gray-500">
            Selling unit: {sellingUnit}
          </div>
        )}
      </div>

      <ProductModal
        title={linkText}
        imageUrl={imageUrl}
        url={productUrl}
        visible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
      />
    </div>
  )
}
